import { useEffect } from 'react';
import Breadcrumb from '../Breadcrumb';
import Section from '../Section';
import PricingSection from '../Section/PricingSection';
import { pageTitle } from '../../helpers/PageTitle';

export default function PricingPage() {
  pageTitle('Pricing');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Breadcrumb title="Pricing List" bgUrl="https://png.pngtree.com/thumb_back/fh260/background/20210814/pngtree-business-gradient-geometric-gray-square-abstract-simple-gray-background-image_759189.jpg" />
      <Section pt="140" ptLg="80" pb="110" pbLg="40">
        <PricingSection />
      </Section>
    </>
  );
}
